import { render, staticRenderFns } from "./MaexxnaComponent.vue?vue&type=template&id=452cda97&"
import script from "./MaexxnaComponent.vue?vue&type=script&lang=js&"
export * from "./MaexxnaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports